import { useTheme } from '@mui/material';

export const useVariant = (): 'outlined' | 'contained' => {
    const theme = useTheme();
    return theme.palette.mode === 'dark' ? 'outlined' : 'contained';	
};